import React from 'react'
import { CookiesProvider } from 'react-cookie'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import ReactDOM from 'react-dom/client'

import { Home } from "routes/home"
import { TenantRoot } from "routes/tenantRoot"
import { ErrorPage } from "routes/errorPages"
import { UnknownPage } from "routes/errorPages/unknownPage"

import './index.scss'
require(`./index.${process.env.NODE_ENV}.scss`)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <BrowserRouter>
        <Routes>
          <Route path={'/'} element={<Home />} />
          <Route path={'/:domain/*'} element={<TenantRoot />} />
          <Route path={'/error/:code'} element={<ErrorPage />} />
          <Route path={'*'} element={<UnknownPage />} />
        </Routes>
      </BrowserRouter>
    </CookiesProvider>
  </React.StrictMode>
)
